import React, {useRef, useEffect, useMemo} from 'react';
import DataGrid, {Column, Label, Lookup} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {FormRef, GroupItem, SimpleItem} from "devextreme-react/form";
import Guid from "../../models/Guid";
import {Gallery} from "devextreme-react";
import IProvince from '../../models/IProvince';
import {FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar} from '../base';
import useCustomDataSource, {IFormBaseDataSourceOptions, Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';
import ConfigurationPays from './configuration-pays';

interface IConfigurationProvincesProps {
    isModeSelection?: boolean
}

export default function ConfigurationProvinces({isModeSelection}: IConfigurationProvincesProps) {
    const provinceFormDataSource = useCustomDataSource<IProvince, IProvince>({path: "province", primaryKey: "idProvince"});
    const {setMainForm, selectedDataRow: selectedProvince, setIsFieldModifier, mode, setMode, setSelectedDataRow, isFieldModifier, onFieldDataChanged} = provinceFormDataSource;
    const {editorOptions: paysEditorOption, PopupGestion: PopupConfigurationPays} = useLookUpBase({isModeModifier: mode !== Mode.Lecture, controllerName: 'pays', setDataRow: () => setDataRow("idPays"), showClear: mode !== Mode.Lecture});
    const formRef = useRef<FormRef>(null);

    const rereOptions = useMemo(() => {
        return {editorOptions: "dxGallery"};
    }, []);

    const codeEditorOptions = useMemo(() => {
        return {width: "40px"};
    }, []);

    const setDataRow = (e: string) => {
        setSelectedDataRow((prev: IProvince) => (
            {...prev, [e]: Guid.empty.toString()}
        ));
        setIsFieldModifier(true);
    }

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    useEffect(() => {
        if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
    }, [mode])

    const onSelectionchanged = (item: any, e: string) => {
        setIsFieldModifier(true);
        setSelectedDataRow((prev: IProvince) => {
            return {...prev, [e]: item.id}
        })
    }

    const renderCountry = (data: any) => {
        if (["ON", "QC", "NS", "NB", "MB", "BC", "PE", "SK", "AB", "NL", "NT", "YT", "NU"].includes(data.data.code))
            return "CANADA"
        return "ETATS-UNIS"
    }

    return (
        <FormListBase data={provinceFormDataSource}>
            <FormListBaseGrid dataSource={provinceFormDataSource.dataSource} onFocusedRowChanged={() => {
                if (mode === Mode.Modifier) setMode(Mode.Lecture);
            }}>
                <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false}/>
                <Column key={"grid-col-description-en"} dataField={"descriptionAnglais"} caption="Description anglaise" allowHiding={true}/>
                <Column key={"grid-col-code"} dataField={"code"} caption="Code" allowHiding={false}/>
                <Column key={"grid-col-pays"} caption="Pays" allowHiding={false} cellRender={renderCountry}/>
            </FormListBaseGrid>
            <FormListBaseToolbar removeBlocked={true} headerText={`${selectedProvince?.description || ''}`} sauvegarderOptions={{disabled: !isFieldModifier}} annulerOptions={{disabled: !isFieldModifier}} effacerOptions={{visible: false, disabled: !isFieldModifier}}/>
            {!isModeSelection || isModeSelection && mode !== Mode.Lecture
                ? <FormListBaseTab>
                    <PopupConfigurationPays onSelectionchanged={(i) => onSelectionchanged(i, 'idpays')}>
                        <ConfigurationPays isModeSelection={true}/>
                    </PopupConfigurationPays>
                    <TabItem title="Informations">
                        {/* <div style={{ position: "relative", float: "left" }}> */}
                        <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedProvince || {} as IProvince} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                            <GroupItem>
                                <SimpleItem key={"frm-description"} dataField={"description"}>
                                    <Label text='Description française'/>
                                </SimpleItem>
                                <SimpleItem key={"frm-description-en"} dataField={"descriptionAnglais"}>
                                    <Label text='Description anglaise'/>
                                </SimpleItem>
                                <SimpleItem key={"frm-code"} dataField={"code"} editorOptions={codeEditorOptions}/>
                                <SimpleItem key={"frm-pays"} dataField={"idPays"} editorType={"dxSelectBox"} editorOptions={paysEditorOption}>
                                    <Label text={"Pays"}/>
                                </SimpleItem>
                                <GroupItem caption={"Lieu de résidence"}>
                                    <SimpleItem key={"frm-residentQuebec"} dataField={"residentQuebec"} editorType={"dxCheckBox"}>
                                        <Label text={"Québec"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-residentCanada"} dataField={"residentCanada"} editorType={"dxCheckBox"}>
                                        <Label text={"Canada"}/>
                                    </SimpleItem>
                                    <SimpleItem key={"frm-residentEtatsUnis"} dataField={"residentEtatsUnis"} editorType={"dxCheckBox"}>
                                        <Label text={"États-Unis"}/>
                                    </SimpleItem>
                                </GroupItem>
                            </GroupItem>
                        </Form>
                        {/* </div> */}
                    </TabItem>
                    <TabItem title="Système"><FormSysteme formData={selectedProvince || {} as IProvince}/></TabItem>
                </FormListBaseTab> : null
            }
        </FormListBase>
    );
}